import React, { useEffect, useState }from 'react';
import logo from './logo.svg';
import './App.css';

// import exampleTxt from './longnecks.txt'

import cantoeTxt from './cantoes.txt'

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { stringify } from 'querystring';

import Button from '@mui/material/Button';
import { Box, Container, SxProps, TextField } from '@mui/material';

import CantopunkTable from './components/nftLine/Cantopunks';
import CantoesTable from './components/nftLine/Cantoes';
import LongneckTable from './components/nftLine/Longnecks';
import LongneckGrid from './components/nftLine/LongneckGrid';

import bambooGif from './assets/bamboo.gif';

import {
  BrowserRouter as Router,
  Route,
  Link,
  Routes
} from "react-router-dom";
import { width } from '@mui/system';
import ResponsiveAppBar from './components/header/ResponsiveAppBar';


const appContainerStyles: SxProps = {
  backgroundImage: `url(${bambooGif})`,
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
}

const tableBoxStyles: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '50%',
}

function App() {


  return (
    <Router>

    <Box className="App" sx={appContainerStyles}>
    <ResponsiveAppBar />
              {/* <Route path="/" element={LongneckTable()}/> */}

      {/* <Box sx={tableBoxStyles}> */}
        <Routes>
          <Route path="/" element={LongneckGrid()}/>
          <Route path="/Longnecks" element={LongneckTable()}/>
          <Route path="/Cantopunks" element={CantopunkTable()}/>
          <Route path="/Cantoes" element={CantoesTable()}/>
        </Routes>
      {/* </Box> */}
    </Box>


    </Router>

  );
}

export default App;

